"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReviewProviderTypes = void 0;
var ReviewProviderTypes;
(function (ReviewProviderTypes) {
    ReviewProviderTypes["DEFAULT"] = "SITE";
    ReviewProviderTypes["REEVOO"] = "REEVOO";
})(ReviewProviderTypes || (exports.ReviewProviderTypes = ReviewProviderTypes = {}));
//# sourceMappingURL=ProductReviewTypes.js.map